<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="userForm">
    <div class="certificate-container">
      <div class="certificate-content">
        <fieldset>
          <legend>Datos del Usuario</legend>

          <div class="row">
            <!-- <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input type="text" matInput formControlName="name">
              </mat-form-field>
            </div> -->
            <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Email - (Acceso App)</mat-label>
                <input type="email" matInput formControlName="email">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Constreseña - (Acceso App)</mat-label>
                <input type="password" matInput formControlName="password">
              </mat-form-field>
            </div>

            <div class="col-12 col-md-3">
              <mat-form-field>
                <mat-label>Activo</mat-label>
                <mat-select formControlName="active" readonly>
                  <mat-option [value]="true">Activo</mat-option>
                  <mat-option [value]="false">Inactivo</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input type="text" matInput formControlName="name">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Apellidos</mat-label>
                <input type="text" matInput formControlName="lastname">
              </mat-form-field>
            </div>
            <div class="col-12 col-md">
              <mat-form-field>
                <mat-label>Teléfono</mat-label>
                <input type="phone" matInput formControlName="telephone">
              </mat-form-field>
            </div>

            <ng-container *ngIf="user && user.id > 0">
              <div class="col-12 col-md">
                <mat-form-field>
                  <mat-label>Peso</mat-label>
                  <input type="number" matInput formControlName="weight">
                </mat-form-field>
              </div>

              <div class="col-12 col-md">
                <mat-form-field>
                  <mat-label>Altura</mat-label>
                  <input type="number" matInput formControlName="height">
                </mat-form-field>
              </div>

              <div class="col-12 col-md">
                <mat-form-field>
                  <mat-label>Cintura</mat-label>
                  <input type="number" matInput formControlName="waist">
                </mat-form-field>
              </div>
            </ng-container>

          </div>

        </fieldset>
        <br>
        <button class="float-right" mat-raised-button color="primary" (click)="save()" [disabled]="userForm.invalid">{{userForm.controls.id.value > 0 ? 'Actualizar' : 'Guardar' }}</button>
      </div>

    </div>
  </form>
</mat-dialog-content>
<hr>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions>


